// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"30b68495","201":"fe147da8","268":"073f0a03","323":"928f0a4e","528":"2536b7ef","548":"2bdb8709","708":"8e2d3560","869":"41bf95da"}[chunkId] + ".chunk.js";
};